import { t } from '@lingui/macro';

import Panel from '../../page-framework/panel/PanelDecorator';
import { panelPropTypes, panelPropDefaults } from '../../page-framework/panel/PanelPropTypes';
import { COLUMN_TYPES } from '../../data-table/DataTableColumns';
import { useQueryLoader } from '../../data-table/Loaders';
import { filterId as businessServiceFilterId } from '../../filters/business-service-filter/BusinessServiceFilter';
import { usePageStateValue } from '../../../stores/PageStateStore';
import ReportingDataTable from '../../data-table/ReportingDataTable';
import { statusFilterId, timeRangeFilterId } from '../../filters';
import { getLogger } from '../../../utilities/UseLog';

const log = getLogger('ImpactedBusinessServicesPanel');

const title = t`Impacted Business Services`;

const sorters = [{ property: 'status', direction: 'desc' }];

function ImpactedBusinessServicesPanel(props) {
    log.debug('ImpactedBusinessServicesPanel');

    const [queryId] = usePageStateValue({ key: 'queryId' });

    const dataSource = {
        url: '/query/problemBusinessServices',
        params: {
            type: 'businessService',
            entityFields: 'name',
            metrics: ['status', 'bsSiteCounts', 'bsInfrastructureCounts', 'queryId'],
            queryId,
            trends: ['status'],
            sort: 'status',
            renderAsEntity: true,
        },
    };

    const columns = [
        {
            type: COLUMN_TYPES.DRILLINLINK,
            title: t`Business Service`,
            sortable: true,
            mapping: 'businessservice.name',
            width: 250,
            link: {
                target: '/business-service-detail',
                mappedFilterParams: {
                    [businessServiceFilterId]: 'businessservice',
                },
                pageStateParams: ['SelectedTime'],
            },
        },
        {
            title: t`Impacted Sites`,
            width: 160,
            sortable: true,
            align: 'center',
            sortProperty: 'DIVIDE(bsSiteCounts.affected, bsSiteCounts.total)',
            mapper: (row) => `${row.bsSiteCounts?.affected} / ${row.bsSiteCounts?.total}`,
        },
        {
            title: t`Problem Infrastructure`,
            width: 200,
            sortable: true,
            align: 'center',
            sortProperty: 'DIVIDE(bsInfrastructureCounts.affected, bsInfrastructureCounts.total)',
            mapper: (row) => `${row.bsInfrastructureCounts?.affected} / ${row.bsInfrastructureCounts?.total}`,
        },
        {
            type: COLUMN_TYPES.STATUSTREND,
            title: t`Status Trend`,
            sortable: true,
            sortProperty: 'status',
            mapping: 'trends.status.data',
        },
    ];

    const loader = useQueryLoader(dataSource);

    return (
        <ReportingDataTable
            panelProps={props}
            loader={loader}
            columns={columns}
            sorters={sorters}
            deletedMapping="businessservice.deleted"
        />
    );
}

ImpactedBusinessServicesPanel.propTypes = panelPropTypes;

ImpactedBusinessServicesPanel.defaultProps = {
    ...panelPropDefaults,
    title,
    autoHeight: true,
    minContentHeight: 130,
};

export default Panel({
    filters: {
        required: [timeRangeFilterId],
        optional: [statusFilterId],
    },
})(ImpactedBusinessServicesPanel);
